<div>
    <div class="div-franja">
        <img src="/estadisticas-economicas/assets/img/logolinea-brcblanco-footer.svg" class="img-logo-mona">
    </div>
</div>
<div id="encustaSatisfaccion" class="div-modal-dialog">

    <!--********************************************************* PARTE 1 TITULO **********************************************-->
    <div>
        <div class="div-boton-cerrar-dialog"><button mat-button mat-dialog-close (click)="closeDialog()">X</button>
        </div>
        <div>
            <h1 class="metadata-titulo">Compártanos su opinión</h1>
        </div>
    </div>

    <!--********************************************************* PARTE 3 CONTENIDO **********************************************-->
    <div id="tipoEncuestaNormal">
        <div class="div-contenedor-calificacion" *ngIf="!isAgradecimientos">
            <div class="div-razon-calificacion">
                <label>Por favor indíquenos sus comentarios:</label>
                <textarea name="razonCalificación" id="razonCalificacion" [(ngModel)]="razonOpinion"
                    class="textarea-razon-calificacion"></textarea>
            </div>
            <div class="div-texto-info">
                <div class="div-campo-correo">
                    <label>Ingrese su correo electrónico:</label>
                    <input #myInput type="email" id="myInput" [(ngModel)]="correoElectronico" class="input-text-catalogo"
                        placeholder="Correo electrónico" title="Correo electrónico">
                    <small *ngIf="errores.correoObligatorio">El correo es obligatorio</small>
                </div>

            </div>
            <fieldset toggleSpeed="500">
                <legend> Protección de Datos Personales </legend>
                <p class="texto-proteccion-datos-personales" [innerHTML]="parrafoTratamientoDatos">
                </p>
                <div class="div-check-acepto">
                    <label>Acepto:
                        <input type="checkbox" [(ngModel)]="proteccionDatosPersonales" >
                       </label>
                </div>
                
                
            </fieldset>
            <div class="div-texto-info">
                <div>
                    <p>Si tiene alguna sugerencia, petición de información adicional, queja, reclamo o felicitación
                        sobre el indicador o tema que está consultando,
                        le informamos que el Banco de la República cuenta con medios oficiales para su recepción, por lo
                        que solicitamos sean enviadas a través del
                        <a href="https://www.banrep.gov.co/atencion-ciudadano" target="_blank">Sistema de Atención a la
                            Ciudadanía</a> para poder darles la debida gestión.
                    </p>
                </div>
            </div>
            <div class="div-button">
                <div *ngIf="proteccionDatosPersonales" class="div-boton" (click)="enviarOpinion()">
                    <a>
                        <p>Enviar</p>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="div-agradecimientos" *ngIf="isAgradecimientos">
        <h2>Gracias por compartirnos su opinión!</h2>
    </div>
    <div class="div-button"><button mat-button mat-dialog-close (click)="closeDialog()">Cerrar</button></div>
</div>